let args = {
    loop: false,
    speed: 1000,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false, // Ensure autoplay doesn't stop on interaction
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: false,
    },
    navigation: {
        nextEl: '.home-slider__navigation__next',
        prevEl: '.home-slider__navigation__prev',
    },
    on: {
        init: function (home_slider) {
            updateSlideCounterHome(home_slider);
        },
        slideChange: function (home_slider) {
            updateSlideCounterHome(home_slider);
        },
        afterInit: function (home_slider) {
            // Jump to the current active bullet on tab
            const button = document.querySelectorAll('#home-slider .home-slider__controls__button');
            button.forEach(function (item) {
                item.addEventListener('keydown', function (event) {
                    if (event.keyCode === 9) {
                        event.preventDefault();
                        const activeBullet = document.querySelector('.swiper-pagination-bullet-active');
                        activeBullet.focus();
                    }
                });
            });

            // Space key to click pagination bullet and focus on h2 when clicked
            const pagination = document.querySelectorAll('#home-slider .swiper-pagination-bullet');
            pagination.forEach(function (item, index) {
                item.addEventListener('keydown', function (event) {
                    if (event.keyCode === 32) {
                        event.preventDefault();
                        item.click();
                    }
                });
                item.addEventListener('click', function() {
                    const h2Element = home_slider.slides[index].querySelector('h2');
                    if (h2Element) {
                        h2Element.focus();
                    }
                });
            });

            // Play/Pause control button
            const controlBtn = document.querySelector('#home-slider .home-slider__controls');
            if (controlBtn) {
                controlBtn.addEventListener('click', function () {
                    if (this.getAttribute('aria-pressed') === 'false') {
                        home_slider.autoplay.pause();
                        this.querySelector('.screen-reader-text').textContent = 'Play';
                        this.querySelector('.home-slider__controls__button').classList.remove('home-slider__controls__button--pause');
                        this.querySelector('.home-slider__controls__button').classList.add('home-slider__controls__button--play');
                        this.setAttribute('aria-pressed', 'true');
                    } else {
                        home_slider.autoplay.resume();
                        updatePauseButton(this);
                    }
                });
            }
        },
        autoplayTimeLeft(s, time, progress) {
            const progressBar = document.querySelector(".home-slider__controls__progress svg");
            if (progressBar) {
                progressBar.style.setProperty("--progress", 1 - progress);
            }
        },
        slidePrevTransitionStart: function () {
            const controlBtn = document.querySelector('#home-slider .home-slider__controls');
            if(controlBtn) {
                updatePauseButton(controlBtn);
            }
        },
        slideNextTransitionStart: function () {
            const controlBtn = document.querySelector('#home-slider .home-slider__controls');
            if(controlBtn) {
                updatePauseButton(controlBtn);
            }
        }
    }
};

function updatePauseButton(controlBtn) {    
    controlBtn.querySelector('.screen-reader-text').textContent = 'Pause';
    controlBtn.querySelector('.home-slider__controls__button').classList.remove('home-slider__controls__button--play');
    controlBtn.querySelector('.home-slider__controls__button').classList.add('home-slider__controls__button--pause');
    controlBtn.setAttribute('aria-pressed', 'false');
}

// Function to update the slide counter
function updateSlideCounterHome(swiper) {
    const currentSlide = swiper.realIndex + 1;
    const totalSlides = swiper.slides.length;

    const currentSlideElement = document.querySelector('.swiper-slide-current');
    const totalSlidesElement = document.querySelector('.swiper-slide-total');

    if (currentSlideElement) {
        currentSlideElement.textContent = currentSlide;
    }

    if (totalSlidesElement) {
        totalSlidesElement.textContent = totalSlides;
    }
}

(function($){
    var initializeBlock = function() {
        const home_slider = new Swiper('#home-slider', args);

        // Update the slide counter on initialization
        updateSlideCounterHome(home_slider);

        // Update the slide counter on slide change
        home_slider.on('slideChange', function () {
            updateSlideCounterHome(home_slider);
        });
    }

    $(document).ready(function(){
        initializeBlock();
    });
})(jQuery);